import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import Header_v2 from '../../components/layout_v2/Header_v2';
import Footer_v2 from '../../components/layout_v2/Footer_v2';

export default function KesimKalinliklariEN() {
  const location = useLocation();

  // Bölge tespiti
  const region: 'ru' | 'us' | 'en' = location.pathname.startsWith('/ru')
    ? 'ru'
    : location.pathname.startsWith('/us')
    ? 'us'
    : 'en';

  const isRussian = region === 'ru';
  const isV2 = region === 'ru' || region === 'us';

  useEffect(() => {
    document.title = isRussian ? 'AJAN LASER — Толщина резки' : 'AJAN LASER - Cutting Thickness';
  }, [isRussian]);

  const materials = [
    { name: isRussian ? 'Железо' : 'Iron', color: 'bg-gray-900', values: [12, 20, 39, 45, 50] },
    { name: isRussian ? 'Нержавеющая сталь' : 'Stainless Steel', color: 'bg-gray-500', values: [8, 18, 37, 55, 61] },
    { name: isRussian ? 'Алюминий' : 'Aluminum', color: 'bg-blue-400', values: [8, 15, 34, 52, 59] },
    { name: isRussian ? 'Латунь' : 'Brass', color: 'bg-yellow-500', values: [5, 8, 12, 23, 30] },
  ];

  const powers = ['3KW', '6KW', '12KW', '15KW', '20KW'];
  const maxValue = 70;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {isV2 ? <Header_v2 region={region as 'ru' | 'us'} /> : <Header />}

      <main className="flex-grow">
        {/* Page Header */}
        <section className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-5xl sm:text-6xl font-bold mb-4">
                {isRussian ? 'Толщина резки' : 'Cutting Thickness'}
              </h1>
              <p className="text-2xl text-gray-300">
                {isRussian ? 'Максимальные возможности резки в зависимости от мощности лазера' : 'Maximum Cutting Capacities by Laser Power'}
              </p>
            </div>
          </div>
        </section>

        {/* Bar Chart Section */}
        <section className="py-8 bg-white">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
            {/* Chart Container */}
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200 p-6">
              {/* Title */}
              <div className="text-center mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  {isRussian ? 'Таблица возможностей резки' : 'Cutting Capacities Table'}
                </h2>
              </div>

              {/* Table Header with MM/IN values */}
              <div className="mb-3">
                <div className="flex items-center">
                  <div className="w-24 flex-shrink-0 text-center">
                    <span className="text-base font-bold text-gray-900">
                      {isRussian ? 'Мощность лазера' : 'Laser Power'}
                    </span>
                  </div>
                  <div className="flex-1 grid grid-cols-7 gap-2 text-center pl-12">
                    {region === 'us' ? (
                      <>
                        <span className="text-base font-semibold text-gray-700">0.39 in</span>
                        <span className="text-base font-semibold text-gray-700">0.79 in</span>
                        <span className="text-base font-semibold text-gray-700">1.18 in</span>
                        <span className="text-base font-semibold text-gray-700">1.57 in</span>
                        <span className="text-base font-semibold text-gray-700">1.97 in</span>
                        <span className="text-base font-semibold text-gray-700">2.36 in</span>
                        <span className="text-base font-semibold text-gray-700">2.76 in</span>
                      </>
                    ) : (
                      <>
                        <span className="text-base font-semibold text-gray-700">10mm</span>
                        <span className="text-base font-semibold text-gray-700">20mm</span>
                        <span className="text-base font-semibold text-gray-700">30mm</span>
                        <span className="text-base font-semibold text-gray-700">40mm</span>
                        <span className="text-base font-semibold text-gray-700">50mm</span>
                        <span className="text-base font-semibold text-gray-700">60mm</span>
                        <span className="text-base font-semibold text-gray-700">70mm</span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Vertical Grid Lines */}
              <div className="relative">
                <div className="absolute inset-0 flex">
                  <div className="w-24 flex-shrink-0"></div>
                  <div className="flex-1 grid grid-cols-7">
                    {[...Array(7)].map((_, i) => (
                      <div key={i} className="border-l border-gray-200"></div>
                    ))}
                  </div>
                </div>

                {/* Chart Rows */}
                <div className="relative space-y-3">
                  {powers.map((power, powerIdx) => (
                    <div key={power} className="flex items-center">
                      <div className="w-24 flex-shrink-0 text-center">
                        <span className="text-xl font-bold text-gray-900">{power}</span>
                      </div>
                      <div className="flex-1 relative">
                        <div className="space-y-1">
                          {materials.map((material, matIdx) => (
                            <div key={matIdx} className="relative h-4">
                              <div
                                className={`h-full ${material.color} rounded transition-all duration-700`}
                                style={{
                                  width: `${(material.values[powerIdx] / maxValue) * 100}%`,
                                }}
                              ></div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Material Legend */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <h3 className="text-center text-lg font-bold text-gray-900 mb-4">
                  {isRussian ? 'Типы материалов' : 'Material Types'}
                </h3>
                <div className="flex items-center justify-center gap-6 flex-wrap">
                  {materials.map((material, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className={`w-6 h-6 rounded ${material.color}`}></div>
                      <span className="text-base font-medium text-gray-700">{material.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Info Box */}
            <div className="mt-12 bg-blue-50 border-l-4 border-blue-500 rounded-lg p-6">
              <div className="flex gap-3">
                <i className="ri-information-line text-blue-500 text-[22px] flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2 text-lg">
                    {isRussian ? 'Важные примечания' : 'Important Notes'}
                  </h4>
                  <ul className="space-y-1 text-gray-700 text-base">
                    <li>• {isRussian ? 'Толщины резки являются максимальными значениями, полученными при оптимальных условиях работы.' : 'Cutting thicknesses are maximum values obtained under optimal working conditions.'}</li>
                    <li>• {isRussian ? 'Фактическая производительность резки может варьироваться в зависимости от качества материала и условий работы.' : 'Actual cutting performance may vary depending on material quality and working conditions.'}</li>
                    <li>• {isRussian ? 'Для получения подробной технической информации и специальных применений, пожалуйста, свяжитесь с нами.' : 'For detailed technical information and special applications, please contact us.'}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Technical Specs Section */}
        <section className="py-20 bg-gray-50">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
                {isRussian ? 'Технические преимущества' : 'Technical Advantages'}
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-14 h-14 bg-[#D62828] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-flashlight-fill text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {isRussian ? 'Высокая мощность' : 'High Power'}
                </h3>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {isRussian 
                    ? 'Источники лазера мощностью до 20 кВт для максимальной производительности и скорости резки.' 
                    : 'Laser sources up to 20KW for maximum cutting capacity and speed.'}
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-14 h-14 bg-[#D62828] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-stack-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {isRussian ? 'Разнообразие материалов' : 'Versatile Material'}
                </h3>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {isRussian 
                    ? 'Возможность резки железа, нержавеющей стали, алюминия, латуни и многих других материалов.' 
                    : 'Ability to cut iron, stainless steel, aluminum, brass and many more materials.'}
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-14 h-14 bg-[#D62828] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-speed-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {isRussian ? 'Максимальная эффективность' : 'Maximum Efficiency'}
                </h3>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {isRussian 
                    ? 'Высокоскоростная резка с точными результатами для максимальной производственной эффективности.' 
                    : 'High-speed cutting with precision results for maximum production efficiency.'}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-white">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-r from-[#D62828] to-[#B91C1C] rounded-2xl p-8 md:p-12 text-center text-white">
              <h2 className="text-4xl sm:text-5xl font-bold mb-4">
                {isRussian ? 'Нужна дополнительная информация?' : 'Need More Information?'}
              </h2>
              <p className="text-2xl mb-8 text-white/90 max-w-2xl mx-auto">
                {isRussian 
                  ? 'Свяжитесь с нами для получения подробных технических характеристик и индивидуальных решений.' 
                  : 'Contact us for detailed technical specifications and custom solutions.'}
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                {region === 'ru' ? (
                  <a
                    href="tel:+74957778817"
                    className="inline-flex items-center px-8 py-4 bg-white text-[#D62828] font-semibold text-lg rounded-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Call for Appointment: +7 (495) 777-88-17
                  </a>
                ) : region === 'us' ? (
                  <a
                    href="tel:4709702526"
                    className="inline-flex items-center px-8 py-4 bg-white text-[#D62828] font-semibold text-lg rounded-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Call for Appointment: 470-970-2526
                  </a>
                ) : (
                  <a
                    href="tel:+904442526"
                    className="inline-flex items-center px-8 py-4 bg-white text-[#D62828] font-semibold text-lg rounded-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Call for Appointment: +90 444 25 26
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      {isV2 ? <Footer_v2 region={region as 'ru' | 'us'} /> : <Footer />}
    </div>
  );
}
